export default "__VITE_ASSET__4DFuTNz5__"